export const topics = [
  {
    slug: "all",
    name: "全部主题",
    desc: "现场直击与瓜田情报的全部内容",
    icon: "ri-layout-grid-line",
    count: 10,
  },
  {
    slug: "star-scene",
    name: "明星现场",
    desc: "演出、发布会与舞台上正在发生的事",
    icon: "ri-mic-line",
    count: 3,
  },
  {
    slug: "screen",
    name: "影视野台",
    desc: "首映、路演与片场台前幕后的现场记录",
    icon: "ri-film-line",
    count: 2,
  },
  {
    slug: "city",
    name: "城市现场",
    desc: "夜市、赛事与街头里的真实瞬间",
    icon: "ri-building-2-line",
    count: 3,
  },
  {
    slug: "sports",
    name: "赛事直击",
    desc: "赛场内外的高光、遗憾与情绪释放",
    icon: "ri-run-line",
    count: 1,
  },
  {
    slug: "internet",
    name: "网络风云",
    desc: "热梗、二创与线上事件的快速追踪",
    icon: "ri-global-line",
    count: 1,
  },
];

export const hotSearch = [
  "音乐节改期现场",
  "清唱救场",
  "夜市热汤摊",
  "马拉松补给争议",
  "乐队重组巡演",
  "赛后感言",
];